export const MOMENT_TYPE = {
  YEAR: 'years',
  QUATER: 'quarters',
  MONTH: 'months',
  WEEK: 'weeks',
  DAY: 'days',
  DATE: 'dates',
  HOUR: 'hours',
  MINUTE: 'minutes',
  SECOND: 'seconds',
  MILLISECOND: 'milliseconds'
};
